export default __webpack_public_path__ + "static/media/mockup-step-5.228988d9.png";